import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useExportacaoList() {
  // Use toast
  const toast = useToast()

  const refExportacaoListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'link_arquivo', label:"Arquivo"},
    { key: 'categoria' },
    { key: 'situacao' },
    { key: 'usuario' },
    { key: 'fim' },
  ]
  const perPage = ref(10)
  const currentPage = ref(1)
  const perPageOptions = [10, 15, 25, 50, 100]
  const searchQuery = ref('')
  const situacaoFilter = ref(null)

  const dataMeta = ref({})


  const refetchData = () => {
    refExportacaoListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, situacaoFilter], () => {
    refetchData()
  })

  const fetchExportacoes = (ctx, callback) => {
    store
      .dispatch('app-exportacao/fetchExportacoes', {
        busca: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        // situacao: situacaoFilter.value,
      })
      .then(response => {
        const { data, meta } = response.data     
        callback(data)
        dataMeta.value = meta
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching exportacao list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveExportacaoStatusVariant = status => {
    if (status === 'PENDENTE') return 'secondary'
    if (status === 'EM PROGRESSO') return 'info'
    if (status === 'FINALIZADO') return 'success'
    if (status === 'FALHA') return 'danger'
    return 'primary'
  }

  return {
    fetchExportacoes,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    refExportacaoListTable,

    resolveExportacaoStatusVariant,
    refetchData,

    // Extra Filters
    situacaoFilter,
  }
}
